import { render } from "./EnTabHeader.vue?vue&type=template&id=7b1de02f"
import script from "./EnTabHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./EnTabHeader.vue?vue&type=script&setup=true&lang=js"

import "./EnTabHeader.vue?vue&type=style&index=0&id=7b1de02f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/tabs/EnTabHeader/EnTabHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b1de02f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b1de02f', __exports__)) {
    api.reload('7b1de02f', __exports__)
  }
  
  module.hot.accept("./EnTabHeader.vue?vue&type=template&id=7b1de02f", () => {
    api.rerender('7b1de02f', render)
  })

}


export default __exports__